module.exports = __webpack_public_path__ + "img/bossWechart.f70fb5eb.png";